var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTableIconActiveMobile(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 30,
    viewBox: "0 0 32 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 498"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Rectangle 206",
    style: {
      stroke: "#629A41",
      fill: "none"
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M0 0h32v30H0z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none"
    },
    d: "M.5.5h31v29H.5z"
  })), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 149",
    transform: "translate(.5 8.5)",
    style: {
      stroke: "#0c91a9",
      fill: "none"
    },
    d: "M0 0h31"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 150",
    transform: "translate(9.5 1)",
    style: {
      stroke: "#0c91a9",
      fill: "none"
    },
    d: "M0 0v28"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTableIconActiveMobile);
export default __webpack_public_path__ + "static/media/table-icon-active-mobile.7a681b4db4a740549db6ff5b6e185edd.svg";
export { ForwardRef as ReactComponent };